module.exports = __webpack_public_path__ + "img/marker-oil-refinery-full.25cf0ffb.png";